export const environment = {
  sentryDsn: "https://17a913b648554faf04ef389a036f1dc2@o4511853475790848.ingest.us.sentry.io/4511853530054656",
  production: true,
  apiUrl: "https://certificadostradicionylibertad.co/api/",
  apiUrlV2: "https://certificadostradicionylibertad.co/api/v2",
  PASS_JWT: "QT95NMJWDKELC6R2V8YAH0P3IS4OX1",
  // Login del panel de WordPress (slug definido en WPS Hide Login). Debe coincidir en cada ambiente.
  blogAdminUrl: "/gestion-blog-7q4m/",
  inMaintenance: false,
  frontendSignatureSecret: "h8Fk2!pL9zXw4@mN7qVb"
}
